<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.gamification_character_types', 2),
                        href: meta.links.character_types_index,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navGroupLinks" />
        </div>

        <form :action="meta.links.update" method="post" @submit.prevent="submit" class="bg-gray-100 p-4 m-5">
            <div class="md:grid md:grid-cols-3 xl:grid-cols-4 xxl:grid-cols-5 md:gap-3">
                <AppCard v-for="(student, index) in form.students" :key="student.score_card_id">
                    {{ student.full_name }}
                    <FormSelect
                        v-model="student.gamification_character_type_id"
                        :options="options.characterTypes"
                        :null-option="true"
                        :null-option-text="
                            $t('messages.without_X', { element: $tc('messages.gamification_character_types', 1) })
                        "
                        class="mt-1 w-full"
                    />
                    <FormError :value="form.errors[`students.${index}.gamification_character_type_id`]" class="mt-2" />
                </AppCard>
            </div>

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit" :disabled="form.processing">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import FormError from '@/components/Forms/FormError.vue';
import FormSelect from '@/components/Forms/FormSelect.vue';
import AppButton from '@/components/AppButton.vue';
import AppCard from '@/Shared/AppCard.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        AppCard,
        FormError,
        FormSelect,
        AppButton,
        NavLinks,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'gamificationSet', 'options', 'students'],
    data() {
        return {
            form: this.$inertia.form({
                students: this.students,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
